import { gsap } from 'gsap/gsap-core'

let screenWidth = window.innerWidth

if(screenWidth > 1024) {

  setTimeout(function (){
    const el = document.getElementById("intro-check");
    el.addEventListener("mousemove", parallax);

    function parallax(e) {
      let _mouseX = e.clientX;
      let _mouseY = e.clientY;
      gsap.to("#parallax", 0.5, {
        x: 0.07 * _mouseX,
        y: 0.07 * _mouseY
      });
    }
  }, 2000)




}
